export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/img-worker.b8e525f4.worker.js");
}
